export default {
  	// Set this to the base URL of your sample server, such as 'https://your-app-name.herokuapp.com'.
  	// Do not include the trailing slash. See the README for more information:
  	SAMPLE_SERVER_BASE_URL: 'http://101.53.157.18:1337/amsuser',
  	// OR, if you have not set up a web server that runs the learning-opentok-php code,
  	// set these values to OpenTok API key, a valid session ID, and a token for the session.
  	// For test purposes, you can obtain these from https://tokbox.com/account.
  	//API_KEY: '46332651',
  	API_KEY: '46239202',
  	SESSION_ID: '',
  	TOKEN: ''
};
